export const buildSlashCommandDisplayMetadata = (slashCommand, dslQuery, commands, submittedLabelOverride) => {
    if (!slashCommand)
        return undefined;
    const submittedLabel = submittedLabelOverride || commands.find((c) => c.name === slashCommand)?.submitted_label;
    if (!submittedLabel)
        return undefined;
    const body = dslQuery?.trim() ?? '';
    return {
        items: [
            { text_display: { text: submittedLabel, style: 'primary' } },
            ...(body ? [{ text_display: { text: body, style: 'secondary' } }] : []),
        ],
    };
};
//# sourceMappingURL=buildSlashCommandDisplayMetadata.js.map